<template>
  <div id="app">
    <Head class="container"></Head>
    <div id="app-view" class="container">
      <!-- <Nav></Nav> -->
      <!-- <audio ref="audio" class="aud" autoplay>
        <source src="./assets/bgMusic.mp3" />
       </audio> -->
      <router-view/>
    </div>
    <Footer></Footer>
    
  </div>
</template>

<script>
import Head from '@/components/Head.vue'
// import Nav from '@/components/Nav.vue'
import Footer from '@/components/Footer.vue'

export default {
  name: 'Home',
  components: {
    Head,/* Nav, */Footer
  },
  data() {
    return {
      audioState: false,
    }
  },
  mounted() {
    this.checkZoomAndSetScrollbar();
    window.addEventListener('resize', this.checkZoomAndSetScrollbar);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkZoomAndSetScrollbar);
  },
  methods: {
    openMusic() {
      if(!this.audioState) {
        this.audioState = true;

        this.$refs.audio.play().catch(() => {
          this.audioState = false;
        });
       
      }
    },
    checkZoomAndSetScrollbar() {
      const viewportWidth = window.innerWidth;
      const isHighZoom = viewportWidth < 1280;
      if (isHighZoom) {
        document.body.style.overflowX = 'auto';
        document.body.style.minWidth = '1920px';
        document.body.style.width = '';
        const app = document.getElementById('app');
        if (app) {
          app.style.minWidth = '';
          app.style.width = '';
          app.style.overflowX = 'hidden';
        }
      } else {
        document.body.style.overflowX = 'hidden';
        document.body.style.minWidth = '';
        document.body.style.width = '';
        const app = document.getElementById('app');
        if (app) {
          app.style.minWidth = '';
          app.style.width = '';
          app.style.overflowX = 'hidden';
        }
      }
    }
  }
}
</script>

<style>
html, body {
  width: 100%;
  margin: 0;
  padding: 0;
  overflow-x: hidden; /* 默认禁止横向滚动 */
}

* {
  box-sizing: border-box;
}

.container {
  width: 100%;
  margin: 0 auto;
  padding: 0;
}

@media (max-width: 768px) {
  .container {
    padding: 0 15px;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 10px;
  }
}

#app {
  font-family: 'Source Han Serif', serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  overflow-x: hidden;
  background: url(./assets/background/bg1.png);
  background-position: bottom;
  background-repeat: no-repeat;
  background-color: #f9f9f7;
  background-size: cover;
  margin: 0;
  padding: 0;
  min-width: 100%;
  min-height: 100vh;
}

#app-view {
  display: flex;
  margin-top: 0px;
}

.goToGeneral {
  cursor: pointer;
}

/* 当页面缩放比例大于150%时（基于1920px设计稿），强制出现底部滚动条 */
@media (max-width: 1279px) {
  /* 基础设置：允许横向滚动 */
  html, body {
    overflow-x: auto !important;
    width: 100% !important;
  }
  
  /* 关键：确保内容实际超出视口 */
  body {
    min-width: 1920px !important;
  }
  
  /* 确保主要内容区域可以滚动 */
  #app {
    min-width: 1920px !important;
    width: auto !important;
    overflow-x: hidden !important;
    position: relative !important;
  }
  
  /* 确保所有直接子元素都能正常显示 */
  #app > * {
    min-width: auto !important;
    width: auto !important;
  }
  
  /* 特别处理容器 */
  .container {
    min-width: auto !important;
    width: auto !important;
    margin: 0 auto !important;
    padding: 0 !important;
  }
  
  /* 确保视口本身可以滚动 */
  @viewport {
    width: device-width;
    zoom: 1;
  }
}
</style>


